module.exports = __webpack_public_path__ + "media/St 4-End Screen.c34bbf75.wav";